// extracted by mini-css-extract-plugin
export default {"toggle":"EditSearchIssue_toggle__rTEbF","selectItem":"EditSearchIssue_selectItem__ZWvbn","status":"EditSearchIssue_status__0JpDw"};